import { Card, FAQ } from './types';

export const cards: Card[] = [
    {
      id: 1,
      icon: 'card-icon-shipping-leads.svg',
      title: 'Shipping Leads',
      description: 'Transform your business growth with real-time access to high-quality shipping leads. Connect with lucrative opportunities effortlessly and stay ahead of the competition.',
      link: '/benefits/shipping-leads',
      alt: 'Freight Forwarders Rates',
    },
    {
      id: 2,
      icon: 'card-icon-networking.svg',
      title: 'Networking',
      description: 'Build meaningful partnerships within an exclusive global community. Leverage industry connections to expand your reach and enhance collaboration.',
      link: '/benefits/networking',
      alt: 'Freight Forwarders Benefits',
    },
    {
      id: 3,
      icon: 'card-icon-support.svg',
      title: 'Support',
      description: 'From onboarding to daily operations, DFA provides end-to-end support tailored to your needs, ensuring smooth navigation of industry challenges.',
      link: '/benefits/support',
      alt: 'Freight Forwarders Support',
    },
    {
      id: 4,
      icon: 'card-icon-digital-tools.svg',
      title: 'Digital Tools',
      description: 'Access cutting-edge solutions that optimise processes, track shipments seamlessly and bring unprecedented efficiency to your operations.',
      link: '/digital-tools',
      alt: 'Freight Forwarders Digital Tools',
    },
    {
      id: 5,
      icon: 'card-icon-payment-protection.svg',
      title: 'Brand Reliability',
      description: 'Safeguard your transactions with our secure systems, ensuring financial stability and peace of mind with every deal.',
      link: '/benefits/brand-reliability',
      alt: 'Service Reliability',
    },
];

export const faq: FAQ[] = [
  {
    id: "1",
    question: "What makes DFA's benefits unique for freight forwarders?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          DFA offers an exclusive combination of tools, resources, and networking opportunities tailored to freight forwarders. These benefits address industry challenges like lead generation, secure payments, and access to innovative digital tools, all within a trusted, global alliance.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "How do Shipping Leads work, and what is their value?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Shipping Leads provide freight forwarders with real-time access to valuable business.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "What kind of support can I expect as a DFA member?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          DFA provides 24/7 support, including onboarding assistance, operational guidance, and help with resolving industry-specific issues. Our team is dedicated to ensuring members maximise their benefits.
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "How does DFA ensure the reliability of its network?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          DFA carefully vets all members to maintain a high standard of professionalism and credibility. This allows members to confidently collaborate, knowing they are engaging with trustworthy partners.
        </p>
      `
    ),
  },
  {
    id: "5",
    question: "What are DFA’s Digital Tools, and how can they optimise my business?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          DFA’s suite of digital tools includes shipment tracking, performance analytics, and document management systems. These tools streamline operations, save time and enhance efficiency.
        </p>
      `
    ),
  },
  {
    id: "6",
    question: "How does Payment Protection work for freight forwarders?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          DFA offers a secure payment mechanism that safeguards transactions, ensuring prompt and verified payments. This minimises financial risks, giving members peace of mind in their dealings.
        </p>
      `
    ),
  },
  {
    id: "7",
    question: "Can DFA help me expand my global network?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Absolutely. DFA’s global network connects members with logistics professionals worldwide, facilitating partnerships and collaborations that can open new markets for your business.
        </p>
      `
    ),
  },
  {
    id: "8",
    question: "Is DFA suitable for freight forwarders of all sizes?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Yes, DFA's benefits cater to businesses of all scales, from startups to established firms. Our solutions are flexible and can be tailored to meet the specific needs of your business.
        </p>
      `
    ),
  },
  {
    id: "9",
    question: "How do I get started with DFA?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Getting started is simple! Visit the membership page, choose a package and unlock membership benefits that propel your business forward.
        </p>
      `
    ),
  },
];